<template>
  <div class="device-transfers-view">
    <div
        v-loading="loading"
        class="device-transfers-container">
      <el-table
          :data="deviceTransfers"
          style="width: 100%">
        <el-table-column
            :label="$t('dos.device_transfers.columns.device_id')"
            prop="device_id" />
        <el-table-column
            :label="$t('dos.device_transfers.columns.mac_address')"
            prop="mac_address" />
        <el-table-column
            :label="$t('dos.device_transfers.columns.status')"
            prop="transfer_status" />
        <el-table-column
            :label="$t('dos.device_transfers.columns.old_owner_id')"
            prop="old_owner_id" />
        <el-table-column
            :label="$t('dos.device_transfers.columns.new_owner_id')"
            prop="new_owner_id" />
        <el-table-column
            :label="$t('dos.device_transfers.columns.reason')"
            prop="reason" />
        <el-table-column
            :label="$t('dos.device_transfers.columns.start_date')">
          <template slot-scope="scope">
            {{ formatDate(scope.row.start_date) }}
          </template>
        </el-table-column>
        <el-table-column
            :label="$t('dos.device_transfers.columns.end_date')">
          <template slot-scope="scope">
            {{ formatDate(scope.row.end_date) }}
          </template>
        </el-table-column>
        <template slot="empty">
          {{ $t('dos.device_transfers.empty') }}
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { createNamespacedHelpers as namespace } from "vuex";

const { mapGetters: dosGetters, mapActions: dosActions } = namespace("db/dos");
const { mapGetters: accountGetters } = namespace("db/account");

export default {
  name: "DeviceTransfersView",
  computed: {
    ...dosGetters(["deviceTransfers", "loading", "error"]),
    ...accountGetters(["customerId"]),
  },
  watch: {
    error(newError) {
      if (newError) {
        this.$notify.error({
          title: this.$t("dos.device_transfers.error"),
          message: newError.message || this.$t("dos.device_transfers.error"),
          duration: 0,
        });
      }
    },
  },
  created() {
    const transferRequestId = this.$route.params.transfer_id;
    this.fetchDeviceTransfers({
      transferRequestId,
      userId: this.customerId,
    });
  },
  methods: {
    ...dosActions(["fetchDeviceTransfers"]),
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("MM/DD/YYYY HH:mm Z");
    },
  },
};
</script>

<style scoped>
.device-transfers-container {
  max-height: 500px;
  overflow-y: auto;
}
</style>
